import { z } from 'zod/v3';
import { transformNull } from '../../common/utils';

export const SystemClassifierItemSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  sequenceNumber: z.number(),
  systemValue: z.boolean(),
  parameters: transformNull<string>(z.string(), ''),
});
